import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import axios from "axios";
import './CompleteBody.css'; // Import the CSS file

export default function CompletePageBody() {
    const location = useLocation();
    const { date } = location.state;
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const ordersPerPage = 25;

    useEffect(() => {
        if (!date) {
            console.error('Date not provided');
            return;
        }


        const formattedDate = date;
        if (!formattedDate) {
            console.error('Failed to format date');
            return;
        }

    

        axios.get(`${process.env.REACT_APP_API_URL}/compOrder/${formattedDate}`)
            .then(response => {
               
                const ordersData = response.data;
                setOrders(ordersData);
                setFilteredOrders(ordersData);
            })
            .catch(error => {
                console.error('Error fetching orders:', error);
            });
    }, [date]);

    const indexOfLastOrder = currentPage * ordersPerPage;
    const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
    const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);
    const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleSearch = () => {
        const filtered = orders.filter(order => {
            return order.CustomerPhone.includes(searchTerm);
        });
        setFilteredOrders(filtered);
        setCurrentPage(1); // Reset to first page after search
    };

    const handleRefresh = () => {
        setFilteredOrders(orders);
        setSearchTerm('');
        setCurrentPage(1); // Reset to first page after refresh
    };

    return (
        <div className="container">
            {/* Search and Refresh Section */}
            <div style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
                <input 
                    type="text" 
                    placeholder="Search by customer phone number..." 
                    value={searchTerm} 
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ padding: "10px", flex: "1", marginRight: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                />
                <button 
                    onClick={handleSearch} 
                    style={{ padding: "10px 20px", marginRight: "10px", borderRadius: "5px", backgroundColor: "#009879", color: "white", border: "none", cursor: "pointer" }}
                >
                    Search
                </button>
                <button 
                    onClick={handleRefresh} 
                    style={{ padding: "10px 20px", borderRadius: "5px", backgroundColor: "#ccc", color: "black", border: "none", cursor: "pointer" }}
                >
                    Refresh
                </button>
            </div>

            <table className="styled-table">
                <thead>
                    <tr>
                        <th>Order ID</th>
                        <th>Customer Name</th>
                        <th>Customer Phone</th>
                        <th>Customer Address</th>
                        <th>Customer Pin</th>
                        <th>Product Name</th>
                        <th>Product Weight</th>
                        <th>Product Quantity</th>
                        <th>Product Price</th>
                        <th>Status</th>
                        <th>Order Date</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {currentOrders.map(order => (
                        <tr key={order.OrderId}>
                            <td>{order.OrderId}</td>
                            <td>{order.CustomerName}</td>
                            <td>{order.CustomerPhone}</td>
                            <td>{order.CustomerAddress}</td>
                            <td>{order.CustomerPin}</td>
                            <td>{order.ProductName}</td>
                            <td>{order.ProductWeight}</td>
                            <td>{order.ProductQuantity}</td>
                            <td>{order.ProductPrice}</td>
                            <td>{order.Status}</td>
                            <td>{new Date(order.OrderDate).toLocaleDateString()}</td>
                            <td>{order.Amount}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    &laquo;
                </button>
                {Array.from({ length: totalPages }, (_, i) => (
                    <button
                        key={i + 1}
                        onClick={() => paginate(i + 1)}
                        className={i + 1 === currentPage ? 'active' : ''}
                    >
                        {i + 1}
                    </button>
                ))}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    &raquo;
                </button>
            </div>
        </div>
    );
}
